<div [class]="selectDisabledClass()">
    <el-select name="resultsVersion" [value]="currentVersion()">
        <div class="inline-flex divide-x divide-zinc-300 dark:divide-white/10 rounded-md outline-hidden">
            <div
                class="inline-flex items-center gap-x-1.5 rounded-l-md bg-zinc-300 dark:bg-white/10 px-2 py-1.5 text-primary">
                <el-selectedcontent class="text-xs font-semibold">{{ currentLabel() }}</el-selectedcontent>
            </div>
            <button type="button" aria-label="Change results version" [disabled]="saving()"
                class="inline-flex items-center rounded-l-none rounded-r-md bg-zinc-300 dark:bg-white/10 p-2 hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-primary">
                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                    class="size-5 text-primary forced-colors:text-[Highlight]">
                    <path
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </button>
        </div>

        <el-options anchor="bottom end" popover
            class="max-h-60 overflow-auto shadow-md scrollbar-transparent w-72 origin-top-right divide-y divide-border rounded-md bg-card outline-1 -outline-offset-1 outline-border [--anchor-gap:--spacing(2)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0">
            @for (option of versionOptions; track option.value) {
            <el-option [value]="option.value" (click)="selectResultsVersion(option.value)"
                class="group/option block cursor-pointer p-2 text-sm text-primary select-none focus:bg-zinc-100 focus:text-primary dark:focus:bg-zinc-800 dark:focus:text-white focus:outline-hidden">
                <div class="flex flex-col">
                    <div class="flex justify-between">
                        <p
                            class="m-0 text-primary font-normal group-aria-selected/option:font-semibold in-[el-selectedcontent]:font-semibold group-focus/option:text-primary dark:group-focus/option:text-white">
                            {{ option.label }}</p>
                        <span
                            class="text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary dark:group-focus/option:text-white in-[el-selectedcontent]:hidden">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                    </div>
                    <p
                        class="m-0 mt-1 text-secondary text-xs group-focus/option:text-secondary dark:group-focus/option:text-zinc-300 in-[el-selectedcontent]:hidden">
                        {{ option.description }}</p>
                </div>
            </el-option>
            }
        </el-options>
    </el-select>
</div>
